import styled from 'styled-components';
import { Modal, ModalTitle, MODAL_INNER_GAP } from 'design-system/src/components/Modal';

export type ScheduleTrainingModalProps = {
  onClose: () => void;
};

// the webpage in the iframe has 96px top padding
const webpageTopPadding = '96px';
// subtract MODAL_INNER_GAP from webpageTopPadding so there is still some padding on the
// page in the iframe
const topCropAmount = `calc(${webpageTopPadding} - ${MODAL_INNER_GAP})`;

const CustomModalBody = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: ${MODAL_INNER_GAP};
`;

const StyledIframe = styled.iframe`
  position: absolute;
  border: none;
  width: 100%;
  // crop off a large chunk of the extra space on the top of the iframe to make it look
  // less awkward
  clip-path: inset(${topCropAmount} 0 0 0);
  // make the iframe taller to take up the space that we cropped off
  height: calc(100% + ${topCropAmount});
  // move the iframe up to fill the space left from the crop using negative webpageTopPadding,
  // but then add back the gap between the iframe and the heading and the padding we're leaving
  // on the top of the iframe content
  top: calc(-${webpageTopPadding} + (${MODAL_INNER_GAP} * 2));
  left: 0;
`;

/**
 * A modal with a page for scheduling training
 */
const ScheduleTrainingModal = ({ onClose }: ScheduleTrainingModalProps) => {
  return (
    <Modal wide fullHeight onClose={onClose}>
      <ModalTitle>Schedule training</ModalTitle>
      <CustomModalBody>
        <StyledIframe
          src={'https://cal.com/team/tandem-provider/tandem-training-30-mins'}
          loading="lazy"
          title="Tandem Training for Providers"
          allow="clipboard-write"
          allowFullScreen
        />
      </CustomModalBody>
    </Modal>
  );
};

export default ScheduleTrainingModal;
